import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Typist from "react-typist";

import "../../Styles/Ravi.css";

const Ravi = ({ text }) => {
  const navigator = useNavigate();
  const location = useLocation();
  const [raviext, setRavitext] = useState(true);

  //===============================================
  const raviRef = useRef(null);
  useEffect(() => {
    const topPosition = raviRef?.current?.getBoundingClientRect().top;
    console.log(topPosition);
  }, [raviRef, raviext]);

  return (
    <>
      {
        // location?.state?.prevPath == "/hisstori" ? (
        raviext ? (
          <div className="ravi-wrapper desktop-hidden">
            <div className="Ravi-res">
              <div className="Ravi-res-text">
                <div className="Ravi-res-item">
                  <p className="Ravi-res-item-text">
                    {text && <Typist>{text}</Typist>}
                  </p>

                  <button
                    className="Ravi-res-item-back"
                    onClick={() => setRavitext((s) => !s)}
                  >
                    <p>بزن بریم</p>
                    <img
                      className="Ravi-res-item-back-img"
                      src="/imgs/Common/back.svg"
                    />
                  </button>
                </div>
              </div>

              <div className="PenText_one-left-item-svg">
                <img src="/imgs/Common/pen.svg" alt="pen image" />
              </div>
            </div>
          </div>
        ) : (
          <div
            ref={raviRef}
            className="PenText_one-left-item-svg-res desktop-hidden"
          >
            <img
              src="/imgs/Common/pen.svg"
              alt="pen image"
              onClick={() => setRavitext((s) => !s)}
            />
            <div className="PenText">
              <p>
                <Typist>
                  اگه دوســـت داری نـامه‌ت رو دوبـــاره بخونی، بزن روی کله‌ی من
                  :) هر کتاب، یه نامه داره!
                </Typist>
              </p>
            </div>
          </div>
        )
        // ) : (
        //     raviext ? (
        //         <div className="PenText_one-left-item-svg-res desktop-hidden">
        //             <img
        //                 src="/imgs/Common/pen.svg"
        //                 alt="pen image"
        //                 onClick={() => setRavitext((s) => !s)}
        //             />
        //             <div className="PenText">
        //                 <p>
        //                     اگه دوســـت داری نـامه‌ت رو دوبـــاره بخونی، بزن روی کله‌ی من :)
        //                     هر کتاب، یه نامه داره!
        //                 </p>
        //             </div>
        //         </div>

        //     ) : (
        //         <div className="ravi-wrapper desktop-hidden">
        //             <div className="Ravi-res">
        //                 <div className="Ravi-res-text">
        //                     <div className="Ravi-res-item">
        //                         <p className="Ravi-res-item-text">{text}</p>

        //                         <button
        //                             className="Ravi-res-item-back"
        //                             onClick={() => setRavitext((s) => !s)}
        //                         >
        //                             <p>بزن بریم</p>
        //                             <img
        //                                 className="Ravi-res-item-back-img"
        //                                 src="/imgs/Common/back.svg"
        //                             />
        //                         </button>
        //                     </div>
        //                 </div>

        //                 <div className="PenText_one-left-item-svg">
        //                     <img src="/imgs/Common/pen.svg" alt="pen image" />
        //                 </div>
        //             </div>
        //         </div>
        //     )
        // )
      }
    </>
  );
};

Ravi.defaultProps = {};
export default Ravi;
